import type { OverviewCluster, TrafficLight } from "../api/types";

const ENV_ORDER: Record<string, number> = { dev: 0, eng: 1, qa: 2, prod: 3 };
const ENV_REMAP: Record<string, string> = { hsecqa: "qa" };

export const ENV_LABELS: Record<string, string> = {
    dev: "Development",
    eng: "Engineering",
    qa: "QA",
    prod: "Production",
    other: "Other",
};

/** Sort rank for an env (dev → eng → qa → prod, unknown last), after the same remap groupByEnv applies. */
export function envRank(env?: string): number {
    const raw = env ?? "other";
    return ENV_ORDER[ENV_REMAP[raw] ?? raw] ?? 9;
}

export function groupByEnv(clusters: OverviewCluster[]): [string, OverviewCluster[]][] {
    const groups = new Map<string, OverviewCluster[]>();
    for (const c of clusters) {
        const raw = c.env ?? "other";
        const env = ENV_REMAP[raw] ?? raw;
        const list = groups.get(env) ?? [];
        list.push(c);
        groups.set(env, list);
    }
    return [...groups.entries()].sort((a, b) => (ENV_ORDER[a[0]] ?? 9) - (ENV_ORDER[b[0]] ?? 9));
}

export function worstStatus(clusters: OverviewCluster[]): TrafficLight {
    let worst: TrafficLight = "green";
    for (const c of clusters) {
        if (c.status === "red") return "red";
        if (c.status === "yellow") worst = "yellow";
        else if (c.status === "unknown" && worst === "green") worst = "unknown";
    }
    return worst;
}
